import { takeLatest, put, call } from 'redux-saga/effects';
import {
    setLoading,
    setSuccess,
    setGradeList,
    setGradeCreation,
    clearGradeData,
    setGradeModuleList,
    setGradeModuleListLoading,
    clearGradeModuleData,
    setModuleAvailableList
} from '@store/reducers/gradeReducer';
import { resourceService } from '@libs/axios';
import {
    fetchingGradeList,
    createGrade,
    getGradeDetail,
    updateGrade,
    clearGrade,
    fetchingGradeModuleList,
    fetchTotalModuleList
} from '@store/actions/gradeActions';
import { toast } from 'react-toastify';
import { history } from '@utils/BrowserHistory';
import { ResponseType } from '@store/index';

const API_URL = process.env.REACT_APP_API_URL;

interface FetchGradeListPayload {
    code_name?: string;
    page?: number;
    page_size?: number;
    level_code?: string[];
    status?: number[];
}

function* fetchGradeListData(action: { payload: FetchGradeListPayload }) {
    const { code_name, page, page_size, level_code, status } = action.payload || {};
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + '/api/grades/',
            {
                params: {
                    code_name,
                    page: page ?? 1,
                    page_size: page_size ?? 150,
                    status,
                    level_code
                }
            }
        );
        if (response?.data) {
            yield put(setGradeList(response.data));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        let error: Error = e;
        console.log(error);
    }
}

function* createGradeSaga(action: ReturnType<typeof createGrade>) {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.post, API_URL + '/api/grades/', {
            ...action.payload
        });
        if (response.status == 201) {
            toast.success('Tạo khối lớp mới thành công');
            yield put(setSuccess(true));
            yield put(setLoading(false));
            yield put(setGradeCreation(response.data));
            history.push(`/admin/gradedetail/?mode=view&id=${response.data.id}`);
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error) {
        console.log(error);
        toast.error('Tạo khối lớp mới thất bại');
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* getGradeDetailSaga(action: any) {
    const { id } = action.payload;
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.get, API_URL + `/api/grades/${id}/`);
        if (response?.data) {
            yield put(
                setGradeCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    en_name: response.data?.en_name,
                    level_code: response.data?.level_code,
                    status: response.data?.status
                }),
            );
            yield put(setLoading(false));
        }
    } catch (error) {
        yield put(setLoading(false));
        console.log(error);
    }
}

function* clearGradeSaga(action: any) {
    yield put(clearGradeData());
}

function* updateGradeSaga(action: any) {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const { data, id } = action.payload;
        const updatedData = {
            ...data
        };

        const response: ResponseType = yield call(resourceService.patch, API_URL + `/api/grades/${id}/`, updatedData);
        if (response.status == 200) {
            toast.success('Chỉnh sửa thông tin khối lớp thành công');
            yield put(setSuccess(true));
            yield put(setLoading(false));
            yield put(
                setGradeCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    en_name: response.data?.en_name,
                    level_code: response.data?.level_code,
                    status: response.data?.status
                }),
            );
            history.push(`/admin/gradedetail/?mode=view&id=${response.data.id}`);
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error) {
        console.log(error);
        toast.error('Chỉnh sửa thông tin khối lớp thất bại');
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* fetchGradeModuleListData(action: ReturnType<typeof fetchingGradeModuleList>) {
    yield put(setGradeModuleListLoading(true));
    const { gradeId } = action.payload;
    try {
        const response: ResponseType = yield call(resourceService.get, API_URL + `/api/grades/${gradeId}/modules/`);
        if (response.status == 200) {
            yield put(setGradeModuleList(response.data));
            yield put(setGradeModuleListLoading(false));
        } else {
            console.log(response);
            yield put(setGradeModuleList([]));
            yield put(setGradeModuleListLoading(false));
        }
    }
    catch (error) {
        yield put(setGradeModuleList([]));
        yield put(setGradeModuleListLoading(false));
        console.log(error);
    }
}

function* fetchTotalModuleListSaga(action: any) {
    try {
      yield put(setLoading(true));
      const { filters } = action.payload;
  
      const response: ResponseType = yield call(resourceService.get,
        API_URL + '/api/modules/', {
        params: {
          status: filters.status,
          name: filters.name,
          page: filters.page,
          page_size: filters.page_size,
        }
      }
      )
  
      if (response.status === 200) {
        yield put(setModuleAvailableList(response.data))
        yield put(setLoading(false))
      }
    }
    catch (error) {
      yield put(setLoading(false));
  
    }
  }

function* gradeSaga() {
    yield takeLatest(fetchingGradeList, fetchGradeListData),
        yield takeLatest(createGrade, createGradeSaga),
        yield takeLatest(getGradeDetail, getGradeDetailSaga),
        yield takeLatest(clearGrade, clearGradeSaga),
        yield takeLatest(updateGrade as any, updateGradeSaga),
        yield takeLatest(fetchingGradeModuleList, fetchGradeModuleListData),
        yield takeLatest(fetchTotalModuleList, fetchTotalModuleListSaga)
}

export default gradeSaga;
